<template lang="pug">
.card-inteligencia-territorial-potencial-agropecuario
    .titulo-informativo(v-if='tipoAreaPlantada === "SOJA"') {{ $t('mensagens.inteligenciaTerritorial.imovel.totalAreaPlantadaSoja') }}:
    .titulo-informativo(v-else) {{ $t('mensagens.inteligenciaTerritorial.imovel.totalAreaPlantada') }}:
    .valor-informativo(v-if='tipoAreaPlantada === "SOJA"') {{ formatoNumero(potencialAgropecuario.areaPlantadaUltimaSafraSojaHa) }} ha
    .valor-informativo(v-else) {{ formatoNumero(somaAreaPlantadaCulturas()) }} ha
    .grupo-area-plantada
      .subgrupo-area-plantada
        .separador-personalizado
        .subtitulo-informativo {{ $t('mensagens.inteligenciaTerritorial.imovel.produtividade') }}:
        .subvalores-informativos(v-if='tipoAreaPlantada === "SOJA" && potencialAgropecuario.areaPlantadaUltimaSafraSojaHa && potencialAgropecuario.producaoUltimaSafraSojaKg') {{ formatProdutividadeSaca(potencialAgropecuario.areaPlantadaUltimaSafraSojaHa, potencialAgropecuario.producaoUltimaSafraSojaKg) }} {{ $t('mensagens.inteligenciaTerritorial.imovel.sacasHa') }}
        .subvalores-informativos(v-else-if='tipoAreaPlantada === null') -
        .subvalores-informativos(v-else) -
      .subgrupo-area-plantada
        .separador-personalizado
        .subtitulo-informativo {{ $t('mensagens.inteligenciaTerritorial.imovel.producao') }}:
        .subvalores-informativos(v-if='tipoAreaPlantada === "SOJA" && potencialAgropecuario.producaoUltimaSafraSojaKg') {{ formatKgToneladas(potencialAgropecuario.producaoUltimaSafraSojaKg) }} t
        .subvalores-informativos(v-else-if='tipoAreaPlantada === null') -
        .subvalores-informativos(v-else) -
    el-divider
    .titulo-informativo {{ $t('mensagens.inteligenciaTerritorial.imovel.totalAreaDePastagem') }}:
    .valor-informativo(style='margin-bottom: 16px', v-if='tipoAreaPlantada !== "SOJA" && potencialAgropecuario.areaPastagemHa') {{ formatoNumero(potencialAgropecuario.areaPastagemHa) }} ha
    .valor-informativo(v-else) -
    .separador-personalizado(style='margin-left: 8px !important')
    .titulo-pastagem {{ $t('mensagens.inteligenciaTerritorial.imovel.qualidadePastagem') }}:
    .grupo-area-pastagem
      .subgrupo-area-pastagem
        .conteudo-informativo
          .barra-coloracao-degradacao(style="background-color: #4f7200")
          p {{ $t('mensagens.inteligenciaTerritorial.imovel.degradacaoAusente') }}:
        .subvalores-informativos(v-if='tipoAreaPlantada !== "SOJA" && potencialAgropecuario.areaPastagemDegradacaoAusenteHa') {{ formatoNumero(potencialAgropecuario.areaPastagemDegradacaoAusenteHa) }} ha
        .subvalores-informativos(v-else) -
      .subgrupo-area-pastagem
        .conteudo-informativo
          .barra-coloracao-degradacao(style="background-color: #ae731a")
          p {{ $t('mensagens.inteligenciaTerritorial.imovel.degradacaoIntermediaria') }}:
        .subvalores-informativos(v-if='tipoAreaPlantada !== "SOJA" && potencialAgropecuario.areaPastagemDegradacaoIntermediariaHa') {{ formatoNumero(potencialAgropecuario.areaPastagemDegradacaoIntermediariaHa) }} ha
        .subvalores-informativos(v-else) -
      .subgrupo-area-pastagem
        .conteudo-informativo
          .barra-coloracao-degradacao(style="background-color: #740f0f")
          p {{ $t('mensagens.inteligenciaTerritorial.imovel.degradacaoSevera') }}:
        .subvalores-informativos(v-if='tipoAreaPlantada !== "SOJA" && potencialAgropecuario.areaPastagemDegradacaoSeveraHa') {{ formatoNumero(potencialAgropecuario.areaPastagemDegradacaoSeveraHa) }} ha
        .subvalores-informativos(v-else) -
</template>
<script>
import formatters from '@/utils/formatters';
export default {
    name: 'CardInteligenciaTerritorialPotencialAgropecuario',
    props: {
        potencialAgropecuario: {
            type: Object,
            default: () => {}
        },
        tipoAreaPlantada: String
    },

    data() {
        return {};
    },

    methods: {
        formatoNumero(number) {
            return formatters.formatNumber(number, 0);
        },
        formatProdutividadeSaca(areaHa, producao) {
            let sacas = producao / 60;
            const produtividade = sacas / areaHa;
            return produtividade.toLocaleString('pt-BR', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        },
        formatProdutividadeArroba(areaHa, producao) {
            let arrobas = producao / 15;
            const produtividade = arrobas / areaHa;
            return produtividade.toLocaleString('pt-BR', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        },
        formatKgToneladas(kg) {
            const tonelada = kg / 1000;
            return tonelada.toLocaleString('pt-BR', {minimumFractionDigits: 0, maximumFractionDigits: 2});
        },
        somaAreaPlantadaCulturas() {
          return this.potencialAgropecuario?.areaPlantadaUltimaSafraAlgodaoHa +
          this.potencialAgropecuario?.areaPlantadaUltimaSafraMilhoHa + this.potencialAgropecuario?.areaPlantadaUltimaSafraSojaHa;
        }
    }
};
</script>

<style lang="scss" scoped>
.card-inteligencia-territorial-potencial-agropecuario {
    height: 450px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    flex-direction: column;
    padding: 15px 20px 36px;
    color: var(--primary);
    box-shadow: 0px 0px 10px 0px #0000001A;
}
.titulo-informativo {
  font-size: 16px;
  font-weight: 400;
  align-self: flex-start;
  white-space: nowrap;
}
.valor-informativo {
  color: var(--primary);
  align-self: flex-start;
  margin-top: 5px;
  white-space: nowrap;
  font-weight: 600;
  font-size: 26px;
}
.grupo-area-plantada {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin: 19px 0 14px 10px;
}
p {
    white-space: pre-line;
    margin-bottom: 0 !important;
}
.subgrupo-area-plantada {
  display: flex;
  flex-grow: 1;
  flex-basis: 0%;
  flex-direction: column;
  padding: 3px 0;
}
.subtitulo-informativo {
  font-weight: 400;
}
.subvalores-informativos {
  color: var(--primary);
  font-size: 16px;
  font-weight: 600;
}
.titulo-pastagem {
  justify-content: center;
  font-weight: 400;
  margin: -2px 10px 0 0;
  padding: 3px 8px;
}
.grupo-area-pastagem {
  display: flex;
  gap: 16px;
  white-space: nowrap;
  margin: 16px 10px 0 0;
}
.subgrupo-area-pastagem {
  display: flex;
  flex-grow: 1;
  flex-basis: 0%;
  flex-direction: column;
  padding-left: 5px;
}
.conteudo-informativo {
  display: flex;
  width: min-content;
  justify-content: space-between;
  gap: 4px;
  font-weight: 400;
}
.barra-coloracao-degradacao {
  border-radius: 0.888px;
  align-self: flex-start;
  width: 9px;
  height: 34px;
  margin-top: 4px;
}
.separador-personalizado {
    border: 2px;
    width: 45px;
    border-top: 2px solid var(--secondary-two);
}
</style>
